import { IconBlock, IconInfoOutline } from "@/assets/icons";
import { Stack, Tooltip } from "@mui/material";

type AdminUserStatusIconProps = {
  isPendingActivation: boolean;
  isDisabled: boolean;
};

export const AdminUserStatusIcon = ({ isPendingActivation, isDisabled }: AdminUserStatusIconProps) => {
  if (isDisabled)
    return (
      <Stack justifyContent="center" alignItems="start">
        <IconBlock />
      </Stack>
    );
  if (isPendingActivation) {
    return (
      <Tooltip title="招待送付済みです。アカウント登録およびログイン後にこのマークは消えます。">
        <Stack justifyContent="center" alignItems="start">
          <IconInfoOutline />
        </Stack>
      </Tooltip>
    );
  }
  return null;
};
